import { sortBy } from 'lodash';
import { PackageType } from '../../enums/essential-ui/PackageType';
import { BrandsService } from '../../services/shared/BrandsService';
import { CurrentUser } from '../../types';
import { DealerInfo } from '../../types/DealerInfo';

export const useCommon = (): CommonType => {
  const dealerList = ['Audi', 'Mazda', 'Volvo', 'Volkswagen'];
  const isPrimaryUser = (user: CurrentUser): boolean => {
    if (!user) {
      return false;
    }
    const amEmailAddress = 'automotivemastermind.com';
    return user.isShadowLogin?.toLowerCase() === 'true'
      ? user.shadowUserName.includes(amEmailAddress)
      : user.userName.includes(amEmailAddress);
  };

  const checkForPermission = (permissions: string[], permission: string): boolean => {
    // We have to lowercase permissions and permission in order to make this work
    // in every environment regardles letter casing.
    const lowercasedPermissions = permissions.map((permission) => permission.toLowerCase());
    const lowercasedPermission = permission?.toLowerCase();
    return lowercasedPermissions.includes(lowercasedPermission);
  };

  const getMakeName = (dealerId: string, brandId: number): string => {
    const abbreviation = dealerId?.slice(0, 2);
    if (abbreviation === 'OB') {
      return BrandsService.getByBrandId(brandId);
    }
    return BrandsService.getByDealerId(dealerId);
  };

  const getIsEssentialType = (dealerInfos: DealerInfo[]): boolean => {
    const essentialUIPackageTypes = [
      PackageType.DealerActivator,
      PackageType.DealerActivatorLite,
      PackageType.Blueberry,
      PackageType.BlueberryPlus,
    ];
    let isEssentialType = false;

    const dealerInfo = getDealerInfo(dealerInfos);
    isEssentialType = essentialUIPackageTypes.indexOf(dealerInfo.packageType) > -1;

    return isEssentialType;
  };

  const IsIncentiveAdvantagePackageType = (packageType: number): boolean => {
    const essentialUIPackageTypes = [PackageType.DealerActivator, PackageType.DealerActivatorLite];
    let isIncentiveAdvantagePackageType = false;

    isIncentiveAdvantagePackageType = essentialUIPackageTypes.indexOf(packageType) > -1;

    return isIncentiveAdvantagePackageType;
  };

  const IsEssentialPackageType = (packageType: number): boolean => {
    const essentialUIPackageTypes = [PackageType.Blueberry, PackageType.BlueberryPlus];
    let isEssentialPackageType = false;

    isEssentialPackageType = essentialUIPackageTypes.indexOf(packageType) > -1;

    return isEssentialPackageType;
  };

  const getDealerInfo = (dealerInfos: DealerInfo[], dealerId: string = null): DealerInfo => {
    if (dealerId === null) {
      return dealerInfos[0];
    }

    return dealerInfos.find((dInfo) => dInfo.dealerId.toLowerCase() === dealerId.toLowerCase());
  };

  const getAllDealersInfo = (dealerInfos: DealerInfo[]): DealerInfo[] => {
    const sorted = sortBy(dealerInfos, 'dealerId');
    return sorted;
  };

  return {
    isPrimaryUser,
    checkForPermission,
    getIsEssentialType,
    IsIncentiveAdvantagePackageType,
    IsEssentialPackageType,
    getDealerInfo,
    getAllDealersInfo,
    dealerList,
    getMakeName,
  };
};

type CommonType = {
  isPrimaryUser: (user: CurrentUser) => boolean;
  checkForPermission: (permissions: string[], permission: string) => boolean;
  getIsEssentialType: (dealerInfos: DealerInfo[]) => boolean;
  IsIncentiveAdvantagePackageType: (packageType: number) => boolean;
  IsEssentialPackageType: (packageType: number) => boolean;
  getDealerInfo: (dealerInfos: DealerInfo[], dealerId: string) => DealerInfo;
  getAllDealersInfo: (dealerInfos: DealerInfo[]) => DealerInfo[];
  dealerList: string[];
  getMakeName(dealerId: string, brandId: number): string;
};
